
import {httpservice} from '../services';
import {constants} from '../constant/constant';
import { ACTIVE_SESSIONS } from "../constant/actionTypes";
import moment from 'moment';

export const getActiveSessionData = (obj) => dispatch => {
    dispatch({
        payload: [],
        type: ACTIVE_SESSIONS.GET.INITIATE
    });

    return httpservice()
        .get(`${constants.API.GET_ALL_ACTIVE_SESSON_DATA}?page=${obj.page}&size=${obj.size}`)
        .then(activeSessionsData => {
            const rows = activeSessionsData.data.response.data.sessions;
            const count = activeSessionsData.data.response.data.totalItems;
            const responseData = rows.map(data => {
                data.lastActive = moment(parseInt(data.lastActive)).format('DD/MM/YYYY hh:mm A');
                return data;
            });
            dispatch({
                payload: {data: responseData , count: count},
                type: ACTIVE_SESSIONS.GET.SUCCESS
            });
        })
        .catch(function (error) {
            dispatch({
                payload: error,
                type: ACTIVE_SESSIONS.GET.ERROR
            });
        });
};

export const logoutAllUserSessions = () => {

    return httpservice()
        .delete(`${constants.API.GET_ALL_ACTIVE_SESSON_DATA}`)
        .then(allLogoutSessions => {
            return { data: allLogoutSessions.data, status: 1 };
        })
        .catch(function (error) {
            return { data: error.response && error.response.data ? error.response.data : error, status: 0 };
        });
};

export const logoutSingleUserDevice = (sessionUUID) => {
    return httpservice()
        .get(`${constants.API.SINGLE_ACTIVE_SESSION}?sessionUUID=${sessionUUID}`)
        .then(singleLogoutSession => {
            return { data: singleLogoutSession.data, status: 1 };
        })
        .catch(function (error) {
            return { data: error.response && error.response.data ? error.response.data : error, status: 0 };
        });
};